export default __webpack_public_path__ + "static/19-6cdbbed6faa0e6f7252f8c9537c562c4.jpg";